import { sectionRenderer } from '@theme/section-renderer';
import { RecentlyViewed } from '@theme/recently-viewed-products';

/**
 * Fills a product page's recently viewed list. The viewed products live only in this browser, so
 * the section is rendered again on a search for their ids, and the response replaces this empty
 * shell. With nothing viewed besides the current product, the section stays empty.
 */
class NbaRecentlyViewed extends HTMLElement {
  connectedCallback() {
    const { sectionId, productId } = this.dataset;
    const viewedIds = RecentlyViewed.getProducts().filter((id) => id !== productId);
    if (!sectionId || viewedIds.length === 0) return;

    const url = new URL(Theme.routes.search_url, location.origin);
    url.searchParams.set('q', viewedIds.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');
    // The list is optional: if it can't load, the section stays empty.
    sectionRenderer.renderSection(sectionId, { url }).catch(() => {});
  }
}

if (!customElements.get('nba-recently-viewed')) {
  customElements.define('nba-recently-viewed', NbaRecentlyViewed);
}
